document.addEventListener('DOMContentLoaded', function () {
    AOS.init({ duration: 900, easing: 'ease-out-quad' });
  });

  document.addEventListener('shopify:section:load', function () {
    AOS.refreshHard();
  });
  document.addEventListener('shopify:section:select', function () {
    AOS.refresh();
  });
  window.addEventListener('load', function () {
    AOS.refresh();
  });
